import React from 'react';
import { styles } from '../styles';

const PolicyHeader = ({ policy }) => {
  const statusColor = policy.status === 'Full_Coverage' ? '#28a745' : '#666';
  const coverType = policy.quotation && policy.quotation.additional_details
    ? policy.quotation.additional_details.cover_type
    : 'N/A';

  return (
    <div style={styles.header}>
      <h1 style={styles.headerTitle}>
        Amend Policy
      </h1>
      <div style={styles.headerInfo}>
        <p style={styles.headerText}>
          <strong>Policy Number:</strong> {policy.policy_number}
        </p>
        <p style={{...styles.headerStatus, color: statusColor}}>
          <strong>Status:</strong> {policy.status && policy.status.replace(/_/g, ' ')}
        </p>
        <p style={styles.headerText}>
          <strong>Coverage Type:</strong> {coverType}
        </p>
      </div>
    </div>
  );
};

export default PolicyHeader;
